export const getFileUri = (file) => {
    if (file?.path == null) {
        return null;
    }

    return `${process.env.REACT_APP_API_URL}${file.path}`;
};
